import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Fixed grid + glow behind all public marketing pages (see `_marketing.tsx`). */
export function MarketingPageBackground() {
	return (
		<div
			className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
			aria-hidden
		>
			<div className="absolute -top-52 left-1/2 size-[min(100vw,58rem)] -translate-x-1/2 rounded-full bg-primary/[0.05] blur-3xl dark:hidden" />
			<div className="absolute -top-40 right-[12%] size-[min(42vw,28rem)] rounded-full bg-chart-1/[0.08] blur-3xl dark:bg-chart-1/[0.05]" />
			<div
				className={cn(
					"absolute inset-0 [background-size:4rem_4rem] mask-[linear-gradient(to_bottom,black,transparent_82%)]",
					"opacity-[0.28] [background-image:linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)]",
					"dark:opacity-[0.26] dark:[background-image:linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)]",
				)}
			/>
		</div>
	);
}

export function MarketingShell({ children }: { children: ReactNode }) {
	return (
		<div
			data-testid="marketing-shell"
			className="relative flex min-h-full flex-1 flex-col"
		>
			{children}
		</div>
	);
}

export function MarketingContainer({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<div className={cn("mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", className)}>
			{children}
		</div>
	);
}

export function MarketingSection({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<section className={cn("py-16 sm:py-24", className)}>
			<MarketingContainer>{children}</MarketingContainer>
		</section>
	);
}
